import React, { Component } from 'react';
import Header from './Header';
import { Typography } from 'rmwc/Typography';
import { Elevation } from 'rmwc';

export const NoMatch404 = () => (
  <div>
    <Header />
    <div className="container">
      <div className="col-8 offset-2 text-center">
        <Elevation z={3} className="p-5 mt-5" style={{ background: 'white' }}>
          <Typography use="headline4" tag="div" className="mt-4">
            404: Oops...
          </Typography>

          <Typography use="headline5" tag="div" className="mt-5 mb-4">
            The page you are looking for does not exist. You may have mistyped the address of the page may have moved.
            Please contact support if you think there was an error.
          </Typography>
        </Elevation>
      </div>
    </div>
  </div>
);
